import Hero from "../components/Hero";
import ServiceIamge1 from "../../assets/images/Savings1.jpg";

const ServicesPage = () => {
  return (
    <div>
      <Hero
        title="Our Services"
        backgroundImage={ServiceIamge1}
        titleAlign="center"
        subtitleAlign="center"
      />
    </div>
  );
};

export default ServicesPage;
